export const FUNCTIONAL_DEPARTMENT_TABS = [
  { key: 'COS', label: 'Chief of Sales/State & RH' },
  { key: 'Logistic', label: 'Logistics' },
  { key: 'Technical', label: 'Technical' },
  { key: 'Marketing', label: 'Marketing' },
  { key: 'HR', label: 'HR', blank: true },
];

export const SUB_VIEW_TABS = [
  { key: 'kanban', label: 'Kanban Board' },
  { key: 'impact', label: 'Impact Analysis' },
];

export const COLUMN_ACCENTS = {
  L1: '#475569',
  L2: '#2563EB',
  L3: '#7E22CE',
  L4: '#0E7490',
  L5: '#92400E',
};

export const PRIORITY_STYLES = {
  High: { bg: '#E4E7FF', color: '#3538CD' },
  Medium: { bg: '#D1F5EA', color: '#0F766E' },
  Low: { bg: '#E9E9EC', color: '#5F6368' },
};

export const STATUS_STYLES = {
  'On Track': { bg: '#DFF5E3', color: '#1E7B34' },
  'At Risk': { bg: '#FDECC8', color: '#B4790A' },
  'Pending Approval': { bg: '#FDECC8', color: '#B4790A' },
  'Delayed 5d': { bg: '#FBDADA', color: '#C0392B' },
  '5 Days Ahead': { bg: '#DFF5E3', color: '#1E7B34' },
  Completed: { bg: '#DFF5E3', color: '#1E7B34' },
  Default: { bg: '#FBDADA', color: '#C0392B' },
};
